import React from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

const FooterContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #555;

  & > p {
    margin: 0 10px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  & > span {
    margin: 0 5px;
    color: #aaa;
  }
`;

type FooterProps = {
  firstUrl: string;
  secondUrl: string;
  findIdText?: string;
  findPasswordText?: string;
};

const AuthFooter: React.FC<FooterProps> = ({
  firstUrl,
  secondUrl,
  findIdText = '아이디 찾기',
  findPasswordText = '비밀번호 찾기',
}) => {
  const navigate = useNavigate();

  return (
    <FooterContainer>
      <p onClick={() => navigate(firstUrl)}>{findIdText}</p>
      <span>|</span>
      <p onClick={() => navigate(secondUrl)}>{findPasswordText}</p>
    </FooterContainer>
  );
};

export default AuthFooter;
